import React from 'react';
import { forwardRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import './pdf.css';
import { ArrowForward } from '@material-ui/icons';
import locationPin from '../assets/images/location-pin.svg';
import nearmeicon from '../assets/images/location-arrow.svg';
import calendaricon from '../assets/images/calendar-icon.svg';
import moment from 'moment';

/**
 * Format coordinate values by removing only the last trailing zero
 * if the fractional (decimal) part has more than 7 digits.
 *
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
const formatCoordinate = (value) => {
  if (value === null || value === undefined) return '';
  const s = String(value).trim();
  if (s === '') return '';
  const match = s.match(/^(-?\d+)(?:\.(\d+))?$/);
  if (!match) return s;
  const integerPart = match[1];
  const fractionalPart = match[2] || '';
  if (fractionalPart.length > 7 && fractionalPart.endsWith('0')) {
    const newFraction = fractionalPart.slice(0, -1);
    return newFraction ? `${integerPart}.${newFraction}` : integerPart;
  }
  return s;
};

const CamparsionPdf = forwardRef((props, ref) => {
  const { data } = props;
  return (
    <>
      <div>
        <div ref={ref} className="pdf-main-container">
          {data &&
            data?.length > 0 &&
            data?.map((row, rowIndex) => {
              return (
                <div
                  key={row?.id}
                  className=""
                  style={{
                    pageBreakAfter:
                      rowIndex === data?.length - 1 ? 'auto' : 'always',
                    breakAfter: 'page',
                  }}
                >
                  {row ? (
                    <Row>
                      <h1 className="section-title mt-4">Site Id : {row?.id}</h1>
                    </Row>
                  ) : null}
                  <Row>
                    {row && 
                      row?.actionabletasks &&
                      row?.actionabletasks?.length > 0 &&
                      [...row.actionabletasks].reverse()
                        .sort((a, b) => {
                          if (a.type === 'default') return -1;
                          if (b.type === 'default') return 1;
                          return 0;
                        })
                        .map((col, colIndex) => {
                        return (
                          <Col
                            md={6}
                            className="compare-card-wrapper"
                            key={colIndex}
                          >
                            <div className="img-wrapper">
                              <div
                                className={`ribbon ${
                                  col?.type === 'default' ? 'purpose' : ''
                                }`}
                              >
                                <p>
                                  {col?.type === 'default'
                                    ? 'Proposed Photo'
                                    : 'Start Date Photo'}
                                </p>
                              </div>
                              <img
                                // crossOrigin="anonymous" use when load
                                className="featured-img"
                                src={col?.imageUrl}
                                alt="image"
                              />
                            </div>
                            <div className="content">
                              <div className="content-row">
                                <img
                                  width={20}
                                  height={20}
                                  style={{ marginTop: '3px' }}
                                  src={calendaricon}
                                  alt="Location Icon"
                                  crossOrigin="anonymous"
                                />
                                <p className="mb-0 title">Date:</p>
                                <p className="mb-0">{col?.date? moment(col?.date).format('MMMM DD, YYYY'): ''}</p>
                              </div>
                              <div className="content-row">
                                <img
                                  width={18}
                                  height={18}
                                  src={nearmeicon}
                                  style={{ marginTop: '3px' }}
                                  alt="Location Icon"
                                  crossOrigin="anonymous"
                                />
                                <p className="mb-0 title">Latitude:</p>
                                <p className="mb-0">{formatCoordinate(col?.latitude)}</p>
                                <p className="mb-0 title">Longitude:</p>
                                <p className="mb-0 desc">{formatCoordinate(col?.longitude)}</p>
                              </div>
                              <div className="content-row">
                                <img
                                  width={18}
                                  height={18}
                                  crossOrigin="anonymous"
                                   style={{ marginTop: '3px' }}
                                  src={locationPin}
                                  alt="Location Icon"
                                />
                                <p className="mb-0 title">Address:</p>
                                <p className="mb-0">{`${row?.cityName}, ${row?.locationName}, ${row?.stateName}`}</p>
                              </div>
                              <div className="content-row">
                                <a target="_blank" href={col?.imageUrl}>
                                  Link{' '}
                                  <ArrowForward
                                    style={{ width: 18, height: 18 }}
                                  />
                                </a>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
});
export default CamparsionPdf;

